export default __webpack_public_path__ + "static/media/kitchen3-afterD-2048w.67a2e8e9.avif";